
import { applyMiddleware, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './Reducers';

export const history = createBrowserHistory();

function configureStore(preloadedState) {
  let middlewares = [routerMiddleware(history), thunk];
  if (process.env.NODE_ENV === 'development') {
    middlewares = [...middlewares, createLogger()];
  }
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = composeWithDevTools(...enhancers);

  return createStore(
    createRootReducer(history),
    preloadedState,
    composedEnhancers,
  );
}

export const store = configureStore();



// WEBPACK FOOTER //
// ./src/Store.js